// extracted by css-extract-rspack-plugin
module.exports =  {"block":"FormSubmission__block___OuWLQ"};